// extracted by mini-css-extract-plugin
export var line = "styles-module--line--85dIF";
export var line_odd = "styles-module--line_odd--geZae";
export var item = "styles-module--item--KQPjg";
export var content = "styles-module--content--2-YR9";
export var image = "styles-module--image--325pO";
export var video = "styles-module--video--88DLA";